const RentalCar = (state) => state.RentalCar

export default {
  RentalCar
}
